/**
 * MCN Related Constants
 */
/* eslint-disable */
export const MCN_TITLES = {
    WAITING_FOR_OUTSCAN: "Waiting for OutScan",
    AT_HUB: "At Hub",
    EXPECTING: "Expecting",
    SENT_FOR_HUB: "Sent For Hub",
    DELIVERY_PENDING: "Delivery Pending",
    RECEIVED_DESTINATION_MCN: "Received Destination MCN",
    SENT_FOR_DELIVERY: "Sent For Delivery",
    DELIVERED: "Delivered",
};
